export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-2-dcd2a5ad24d9a1520daf3a35a1a0ed97.webp";